import { dtsAPI } from "../../axios";

export const actions = {

    // Action Type
    GetActionType(context, data){
        return dtsAPI.get(`ProcessTypeActionType/All`);
    },
    GetSingleActionType(context, data){
        return dtsAPI.get(`ProcessTypeActionType/${data}`);
    },
    UpdateActionType(context, data){
        return dtsAPI.put(`ProcessTypeActionType/${data.id}`, data);
    },
    DeleteActionType(context, data){
        return dtsAPI.delete(`ProcessTypeActionType/${data}`);
    },
    CreateActionType(context, data){
        return dtsAPI.post(`ProcessTypeActionType`, data);
    },

}